import { Spinner } from 'components/ui/Spinner/Spinner';
import { FF_SURCHARGE_FLOW_V2 } from 'constants/features';
import { CHECKOUT_PLATFORM } from 'constants/ui';
import { useExperimentFlag } from 'hooks/useExperiments/useExperimentFlag';
import { useSelector } from 'react-redux';
import { getRecipientId, getSenderCountry, getSenderEmail } from 'selectors';
import { CreditCardPaymentForm } from './CreditCardPaymentForm';
import { CreditCardPaymentFormV2 } from './CreditCardPaymentFormV2';

type CreditCardPaymentFormContainerProps = {
  goToStep: (step: string) => void;
  onPrev: () => void;
};

export const CreditCardPaymentFormContainer = ({
  goToStep,
  onPrev,
}: CreditCardPaymentFormContainerProps) => {
  const recipientId = useSelector(getRecipientId);
  const country = useSelector(getSenderCountry);
  const senderEmail = useSelector(getSenderEmail);

  const { value: isV2Enabled, isFetched } = useExperimentFlag({
    flagName: FF_SURCHARGE_FLOW_V2,
    userContext: {
      countryFrom: country,
      platform: CHECKOUT_PLATFORM,
      portalCode: recipientId,
    },
    userEmail: senderEmail as string,
  });

  if (!isFetched) {
    return <Spinner />;
  }

  return isV2Enabled ? (
    <CreditCardPaymentFormV2 goToStep={goToStep} onPrev={onPrev} />
  ) : (
    <CreditCardPaymentForm goToStep={goToStep} />
  );
};
